import { loadingMotiva } from "assets/animations";
import Lottie from "lottie-react";

export default function LoadingLogo() {
	return <Lottie className="w-16 h-16" animationData={loadingMotiva} loop />;
}
